
export default {
  name:'what',
  components: {

  },
  props: {
    screen:{
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      hasLogin:'',
      url: {
        save:SZH.assets.api + '/Login/OutLogin'
      },
      fullscreenLoading:false,
      username:''
    }
  },
  computed: {

  },
  mounted() {
    this.hasLogin = localStorage.getItem('ms_isLogin');
    this.username = localStorage.getItem('ms_username');
  },
  methods: {
    toRegest(){
      this.$router.push({
        path: '/RegisterTH',
      })
    },
    toLogin(){
      this.$router.push({
        path: '/LoginTH',
      })
    },
    turnTo(url){
      this.$router.push({
        path: url,
      })
    },
    loginOut(){
      let self = this;
      self.fullscreenLoading = true;
      self.$http.post(self.url.save,  self.form)
        .then(result => {
          if (result.state == true) { //
            self.$message.success('退出成功!');
            localStorage.removeItem('ms_isLogin');
            localStorage.removeItem('ms_username');
            self.$router.push({
              path:'/LoginTH'
            })
          } else {
            self.$message.error(result.message);
          }
          self.fullscreenLoading = false;
        }, () => {
          // 请求失败
          self.$message.error('退出失败，请检查您的网络是否可用。');
          self.fullscreenLoading = false;
        });
    },
  },
  watch: {

  }
}




// WEBPACK FOOTER //
// ./src/components/HeaderHome/HeaderHome.js